var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63086 1H12.3703C12.4672 1 12.562 1.02814 12.6431 1.08099C12.7243 1.13384 12.7884 1.20914 12.8276 1.29772C12.8668 1.38631 12.8794 1.48437 12.8639 1.57999C12.8484 1.6756 12.8054 1.76466 12.7403 1.83634L8.63061 6.35697C8.54694 6.449 8.50058 6.56892 8.50058 6.6933V10.2324C8.50058 10.3147 8.48026 10.3958 8.44142 10.4683C8.40258 10.5409 8.34642 10.6028 8.27793 10.6484L6.27793 11.9818C6.20263 12.032 6.11512 12.0608 6.02473 12.0652C5.93433 12.0695 5.84445 12.0493 5.76466 12.0066C5.68486 11.9639 5.61816 11.9003 5.57165 11.8227C5.52515 11.745 5.50058 11.6562 5.50058 11.5657V6.6933C5.50058 6.56892 5.45422 6.449 5.37055 6.35697L1.26089 1.83634C1.19573 1.76466 1.15279 1.6756 1.1373 1.57999C1.1218 1.48437 1.13442 1.38631 1.1736 1.29772C1.21279 1.20914 1.27686 1.13384 1.35804 1.08099C1.43921 1.02814 1.53399 1 1.63086 1V1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filter-white.670528462addae513037abb6dc3005d9.svg";
export { ForwardRef as ReactComponent };